import React, { useContext, useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import styles from "./Login.module.css";

const Login = ({
  galleryLogin = false,
  cartLogin = false,
  designBoxLogin = false,
  myPageLogin = false,
}) => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const { setAuthToken, setUser } = useContext(AuthContext);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const submit = async () => {
    if (form.email === "" || form.password === "") {
      return;
    }
    console.log(form);
    const response = await fetch(`${backend_base}/user/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: form.email,
        password: form.password,
      }),
    });
    const data = await response.json();
    if (response.status === 200) {
      setAuthToken(data);
      setUser(data.user);
      localStorage.setItem("authTokens", JSON.stringify(data));
      navigate("/top");
    } else {
      console.log(response);
      console.log(response.message);
      alert("メールアドレス/パスワードエラー");
    }
  };
  return (
    <>
      <Header />
      <div className={styles.login_main}>
        {galleryLogin && (
          <div className={styles.from_gallery_main}>
            <div className={styles.gallery_header01}>Gallery</div>
            <div className={styles.gallery_text01}>
              マイページよりお写真のダウンロードが可能です。
              <br />
              下記よりログインをお願いします。
            </div>
          </div>
        )}
        {designBoxLogin && (
          <div className={styles.from_gallery_main}>
            <div className={styles.gallery_header01}>Design Box</div>
          </div>
        )}
        {myPageLogin && (
          <div className={styles.from_gallery_main}>
            <div className={styles.gallery_header01}>マイページ</div>
          </div>
        )}
        {cartLogin && (
          <div className={styles.from_gallery_main}>
            <div className={styles.gallery_text01}>
              <b>ログインをお忘れではないですか？</b>
              <br />
              お買い物をする場合は下記よりログインをお願いします。
            </div>
          </div>
        )}
        <div
          style={{
            marginTop:
              galleryLogin || cartLogin || designBoxLogin || myPageLogin
                ? "44px"
                : "261px",
          }}
          className={styles.login_box}
        >
          <div className={styles.header}>My Ace ログイン</div>
          <div className={styles.header2}>メールアドレスでログイン</div>
          <div className={styles.header3}>
            ご登録のEメールアドレスを入力してください。
          </div>
          <div className={styles.input1_box}>
            <div className={styles.input1_box_text}>ログインID</div>
            <input
              type="text"
              name="email"
              value={form.email}
              className={styles.input1}
              placeholder="電子メールアドレス"
              onChange={handleChange}
            />
          </div>
          <PasswordInput
            handlePasswordChange={handleChange}
            label={"パスワード"}
            value={form.password}
            placeholderTxt="パスワードを入力"
          />
          <span className={styles.show_info}>半角英数字８文字以上</span>
          <Link to="/forgot-id" className={styles.right_aligned_1}>
            IDを忘れた方はこちら
          </Link>
          <Link to="/forgot-password" className={styles.right_aligned_1}>
            パスワードを忘れた方はこちら
          </Link>
          <button onClick={submit} className={styles.button_main}>
            ログイン
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

const PasswordInput = ({
  label,
  value,
  placeholderTxt,
  handlePasswordChange,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className={styles.input2_box}>
      <label className={styles.input2_box_text}>{label}</label>
      <div className={`d-flex align-items-center pr-2 ${styles.input1}`}>
        <input
          style={{
            border: "none",
            outline: "none",
            margin: 0,
            padding: 0,
            paddingLeft: "20px",
          }}
          name="password"
          type={isPasswordVisible ? "text" : "password"}
          value={value}
          onChange={handlePasswordChange}
          placeholder={`${placeholderTxt}`}
          autoComplete="new-password"
        />
        <span
          className={styles.password_visibility_toggle}
          style={{ cursor: "pointer" }}
          onClick={togglePasswordVisibility}
        >
          {isPasswordVisible ? (
            <HiEye color="#bbb" />
          ) : (
            <HiEyeOff color="#bbb" />
          )}
        </span>
      </div>
    </div>
  );
};

export default Login;
